import { createSlice } from "@reduxjs/toolkit";
import {
  fetchOrders,
  editOrder,
  deleteOrder,
  insertOrder,
  fetchOrderById,
  fetchPhotos,
  fetchVideo,
  deletePhotos,
  deleteVideo,
  GenerateLink,
  SelectPhoto,
  disSelectPhoto,
  orderdownload,
  mediaDownload,
  fetchLabelPhotos,
  compareFace,
  MacAddressgetget,
  generateZipCompare,
} from "./OrderThunks";
import Swal from "sweetalert2";

// Slice
const orderSlice = createSlice({
  name: "order",
  initialState: {
    fetchOrderPending: true,
    orderList: null,
    fetchOrderRejected: null,
    pagination: null,

    insertOrderPending: false,
    insertOrderFulfilled: null,
    insertOrderRejected: null,
    insertProgress: null,

    editOrderFulfilled: null,
    editOrderRejected: null,
    editOrderPending: false,
    isDelete: false,

    fetchOrderByIdPending: false,
    orderById: null,
    fetchOrderByIdRejected: null,

    SelectPhotoPending: false,
    SelectPhoto: null,
    SelectPhotoRejected: null,

    disSelectPhotoPending: false,
    disSelectPhoto: null,
    disSelectPhotoRejected: null,

    GenerateLinkPending: false,
    GenerateLink: null,
    GenerateLinkRejected: null,

    fetchPhotosPending: false,
    photos: null,
    fetchPhotosdRejected: null,
    photosPagination: null,

    fetchVideoPending: false,
    videos: null,
    fetchVideoRejected: null,
    videoPagination: null,

    deletePhotosPending: false,
    deletePhotosRejected: null,

    deleteVideosPending: false,
    deleteVideosRejected: null,

    myPhotos: null,
    myPhotoslording: false,
    error: null,

    MacAddressget: null,
    MacAddressgetPending: false,
    MacAddressgetRejected: null,

    orderdownloadPending: false,
    orderdownloadRejected: null,
    orderdownloadFulfilled: null,

    generateZipPending: false,
    generateZipRejected: null,
    generateZipFulfilled: null,
  },
  reducers: {
    resetInsertOrder: (state) => {
      state.insertOrderPending = true;
      state.insertOrderFulfilled = null;
    },
    resetEditOrder: (state) => {
      state.editOrderFulfilled = null;
      state.editOrderRejected = null;
      state.editOrderPending = true;
    },
    resetIsDelete: (state) => {
      state.isDelete = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrders.pending, (state) => {
        state.fetchOrderPending = true;
      })
      .addCase(fetchOrders.fulfilled, (state, action) => {
        state.fetchOrderPending = false;
        state.orderList = action.payload?.data;
        state.pagination = action.payload?.pagination;
      })
      .addCase(fetchOrders.rejected, (state, action) => {
        state.fetchOrderPending = false;
        state.fetchOrderRejected = action.payload;
      })
      .addCase(insertOrder.pending, (state) => {
        Swal.fire({
          title: "Uploading...",
          text: "Please wait while your order is being processed.",
          icon: "info",
          allowOutsideClick: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });
        state.insertProgress = 0;
        state.insertOrderPending = true;
        state.editOrderRejected = null;
        state.insertOrderFulfilled = null;
      })
      .addCase(insertOrder.fulfilled, (state, action) => {
        state.insertOrderPending = false;
        state.insertOrderRejected = null;
        state.insertProgress = 0;
        state.orderList.unshift(action.payload.order);
      })
      .addCase(insertOrder.rejected, (state, action) => {
        state.insertOrderPending = false;
        state.insertOrderRejected = action.payload;
        state.insertProgress = 0;
        state.insertOrderFulfilled = null;
      })
      .addCase(editOrder.pending, (state) => {
        Swal.fire({
          title: "Uploading...",
          text: "Please wait while your order is being processed.",
          icon: "info",
          allowOutsideClick: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });
        state.editOrderPending = true;
        state.editOrderRejected = null;
        state.editOrderFulfilled = null;
      })
      .addCase(editOrder.fulfilled, (state, action) => {
        state.editOrderPending = false;
        state.editOrderRejected = null;
        state.orderById = action.payload.order?.editOrder;
        
        action?.payload?.order?.images.forEach((item) => {
          if (
            !state.photos.some(
              (existingItem) => existingItem._id === item._id
            )
          ) {
            state.photos.unshift(item);
          }
        });
        
        action?.payload?.order?.videos.forEach((item) => {
          if (
            !state.videos.some(
              (existingItem) => existingItem._id === item._id
            )
          ) {
            state.videos.unshift(item);
          }
        });
      })
      .addCase(editOrder.rejected, (state, action) => {
        state.editOrderPending = false;
        state.editOrderRejected = action.payload;
        state.editOrderFulfilled = null;
      })
      .addCase(deleteOrder.pending, (state) => {
        Swal.fire({
          title: "Processing...",
          text: "Your request is being processed.",
          icon: "info",
          timer: 1500,
          showConfirmButton: false,
        });
        state.isDelete = true;
      })
      .addCase(deleteOrder.fulfilled, (state, action) => {
        const deletedOrderId = action.payload;
        state.orderList = state.orderList.filter(
          (item) => item._id !== deletedOrderId
        );
      })
      .addCase(deleteOrder.rejected, (state, action) => {
        state.isDelete = false;
      })
      .addCase(fetchOrderById.pending, (state) => {
        state.fetchOrderByIdPending = true;
      })
      .addCase(fetchOrderById.fulfilled, (state, action) => {
        state.fetchOrderByIdPending = false;
        state.orderById = action.payload.order;
      })
      .addCase(fetchOrderById.rejected, (state, action) => {
        state.fetchOrderByIdPending = false;
        state.fetchOrderByIdRejected = action.payload;
      })
      .addCase(fetchPhotos.pending, (state) => {
        state.fetchPhotosPending = true;
      })
      .addCase(fetchPhotos.fulfilled, (state, action) => {
        state.fetchPhotosPending = false;
        if (action.payload?.pagination?.page == 1) {
          state.photos = action.payload.data;
        } else {
          action.payload.data.forEach((item) => {
            if (
              !state.photos.some(
                (existingItem) => existingItem._id === item._id
              )
            ) {
              state.photos.push(item);
            }
          });
        }
        state.photosPagination = action.payload.pagination;
      })
      .addCase(fetchPhotos.rejected, (state, action) => {
        state.fetchPhotosPending = false;
        state.fetchPhotosdRejected = action.payload;
      })
      .addCase(fetchLabelPhotos.pending, (state) => {
        state.fetchPhotosPending = true;
      })
      .addCase(fetchLabelPhotos.fulfilled, (state, action) => {
        state.fetchPhotosPending = false;
        if (action.payload?.pagination?.page == 1) {
          state.photos = action.payload.data;
        } else {
          action.payload.data.forEach((item) => {
            if (
              !state.photos.some(
                (existingItem) => existingItem._id === item._id
              )
            ) {
              state.photos.push(item);
            }
          });
        }
        state.photosPagination = action.payload.pagination;
      })
      .addCase(fetchLabelPhotos.rejected, (state, action) => {
        state.fetchPhotosPending = false;
        state.fetchPhotosdRejected = action.payload;
      })
      .addCase(fetchVideo.pending, (state) => {
        state.fetchVideoPending = true;
      })
      .addCase(fetchVideo.fulfilled, (state, action) => {
        state.fetchVideoPending = false;
        if (action.payload?.pagination?.page == 1) {
          state.videos = action.payload.data;
        } else {
          action.payload.data.forEach((item) => {
            if (
              !state.videos.some(
                (existingItem) => existingItem._id === item._id
              )
            ) {
              state.videos.push(item);
            }
          });
        }
        state.videoPagination = action.payload.pagination;
      })
      .addCase(fetchVideo.rejected, (state, action) => {
        state.fetchVideoPending = false;
        state.fetchVideoRejected = action.payload;
      })
      .addCase(deletePhotos.pending, (state) => {
        state.deletePhotosPending = true;
      })
      .addCase(deletePhotos.fulfilled, (state, action) => {
        state.deletePhotosPending = false;
        action.payload.map((id) => {
          state.photos = state.photos.filter((item) => item._id !== id);
        });
      })
      .addCase(deletePhotos.rejected, (state, action) => {
        state.deletePhotosPending = false;
        state.deletePhotosRejected = action.payload;
      })
      .addCase(deleteVideo.pending, (state) => {
        state.deleteVideosPending = true;
      })
      .addCase(deleteVideo.fulfilled, (state, action) => {
        state.deleteVideosPending = false;
        action.payload.map((id) => {
          state.videos = state.videos.filter((item) => item._id !== id);
        });
      })
      .addCase(deleteVideo.rejected, (state, action) => {
        state.deleteVideosPending = false;
        state.deleteVideosRejected = action.payload;
      })
      .addCase(GenerateLink.pending, (state) => {
        state.GenerateLinkPending = true;
      })
      .addCase(GenerateLink.fulfilled, (state, action) => {
        state.GenerateLinkPending = false;
        state.orderList = state.orderList.map((item) => {
          if (item._id === action.payload._id) {
            return action.payload;
          } else {
            return item;
          }
        });
      })
      .addCase(GenerateLink.rejected, (state, action) => {
        state.GenerateLinkPending = false;
        state.GenerateLinkRejected = action.payload;
      })
      .addCase(compareFace.pending, (state) => {
        state.myPhotoslording = true;
       
      })
      .addCase(compareFace.fulfilled, (state, action) => {
        state.myPhotoslording = false;
        
        Swal.close();
        state.myPhotos = action?.payload?.data;
      })
      .addCase(compareFace.rejected, (state, action) => {
        Swal.close();
        Swal.fire({
          icon: "error",
          title: "Error",
          text: (typeof action?.payload === 'string' && action.payload.trim()) ? action.payload : 'Face not found. Please try another selfie or better lighting.',
          timer: 3000,
          showConfirmButton: false,
        });
        state.myPhotoslording = false;
        state.disSelectPhotoPending = false;
        state.disSelectPhotoRejected = action.payload;
      })
      .addCase(generateZipCompare.pending, (state) => {
        state.generateZipPending = true;
        state.generateZipRejected = null;
      })
      .addCase(generateZipCompare.fulfilled, (state, action) => {
        state.generateZipPending = false;
        state.generateZipFulfilled = action.payload;
      })
      .addCase(generateZipCompare.rejected, (state, action) => {
        state.generateZipPending = false;
        state.generateZipRejected = action.payload;
      })
      .addCase(SelectPhoto.pending, (state) => {
        state.SelectPhotoPending = true;
      })
      .addCase(SelectPhoto.fulfilled, (state, action) => {
        state.SelectPhotoPending = false;
        
        // Update the photo in photos array
        state.photos = state?.photos.map((item) => {
          if (item._id === action.payload.photo._id) {
            return action.payload.photo;
          } else {
            return item;
          }
        });
        
        // Update the photo in myPhotos array
        state.myPhotos = state.myPhotos?.map((item) => {
          if (item._id === action.payload.photo._id) {
            return action.payload.photo;
          } else {
            return item;
          }
        });
        
        // Update the selected count in orderById
        if (state.orderById) {
          state.orderById.selectedPhotosCount = action.payload.selectedPhotosCount;
          
          // Update label selected count if available
          if (action.payload.labelSelectedCount !== undefined && state.orderById.label) {
            state.orderById.label = state.orderById.label.map(label => {
              if (label._id === action.payload.photo.label) {
                return { ...label, selectedCount: action.payload.labelSelectedCount };
              }
              return label;
            });
          }
        }
      })
      .addCase(SelectPhoto.rejected, (state, action) => {
        state.SelectPhotoPending = false;
        state.SelectPhotoRejected = action.payload;
      })
      .addCase(disSelectPhoto.pending, (state) => {
        state.disSelectPhotoPending = true;
      })
      .addCase(disSelectPhoto.fulfilled, (state, action) => {
        state.disSelectPhotoPending = false;
        
        // Update the photo in photos array
        state.photos = state.photos?.map((item) => {
          if (item._id === action.payload.photo._id) {
            return action.payload.photo;
          } else {
            return item;
          }
        });
        
        // Update the photo in myPhotos array
        state.myPhotos = state.myPhotos?.map((item) => {
          if (item._id === action.payload.photo._id) {
            return action.payload.photo;
          } else {
            return item;
          }
        });
        
        // Update the selected count in orderById
        if (state.orderById) {
          state.orderById.selectedPhotosCount = action.payload.selectedPhotosCount;
          
          // Update label selected count if available
          if (action.payload.labelSelectedCount !== undefined && state.orderById.label) {
            state.orderById.label = state.orderById.label.map(label => {
              if (label._id === action.payload.photo.label) {
                return { ...label, selectedCount: action.payload.labelSelectedCount };
              }
              return label;
            });
          }
        }
      })
      .addCase(disSelectPhoto.rejected, (state, action) => {
        state.disSelectPhotoPending = false;
        state.disSelectPhotoRejected = action.payload;
      })
      .addCase(orderdownload.pending, (state) => {
        // Optional: Add loading state if needed
        state.orderdownloadPending = true;
        state.orderdownloadRejected = null;
        state.orderdownloadFulfilled = null;
      })
      .addCase(orderdownload.fulfilled, (state, action) => {
        state.orderdownloadPending = false;
        state.orderdownloadRejected = null;
        state.orderdownloadFulfilled = action.payload;
        Swal.close();
      })
      .addCase(orderdownload.rejected, (state, action) => {
        state.orderdownloadPending = false;
        state.orderdownloadRejected = action.payload;
        state.orderdownloadFulfilled = null;
        // Handle error state if needed
      })
      .addCase(mediaDownload.pending, (state) => {
        // Optional: Add loading state if needed
      })
      .addCase(mediaDownload.fulfilled, (state, action) => {
        Swal.close();
      })
      .addCase(mediaDownload.rejected, (state, action) => {
        // Handle error state if needed
      })
      .addCase(MacAddressgetget.pending, (state) => {
        state.MacAddressgetPending = true;
      })
      .addCase(MacAddressgetget.fulfilled, (state, action) => {
        state.MacAddressgetPending = false;
        state.MacAddressget = action.payload;
      })
      .addCase(MacAddressgetget.rejected, (state, action) => {
        state.MacAddressgetPending = false;
        state.MacAddressgetRejected = action.payload;
      });
  },
});

export const { resetInsertOrder, resetEditOrder, resetIsDelete } =
  orderSlice.actions;
export default orderSlice.reducer;